import { TYPES } from "./finance_manager.type";
import dayjs from "dayjs";

const initState = {
  financeManagerAll: null,
  financeManagerOpenAdd: false,
  financeManagerOpenEdit: false,
  financeManagerSelected: null,
  financeManagerSearch: "",
  //
  financeManagerDates: [dayjs().subtract(1, "months"), dayjs()],
};

const financeManagerReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_FINANCE_MANAGER_ALL:
      return {
        ...state,
        financeManagerAll: payload,
      };

    case TYPES.SET_FINANCE_MANAGER_OPEN_ADD:
      return {
        ...state,
        financeManagerOpenAdd: payload,
      };

    case TYPES.SET_FINANCE_MANAGER_OPEN_EDIT:
      return {
        ...state,
        financeManagerOpenEdit: payload,
      };

    case TYPES.SET_FINANCE_MANAGER_SELECTED:
      return {
        ...state,
        financeManagerSelected: payload,
      };

    case TYPES.SET_FINANCE_MANAGER_SEARCH:
      return {
        ...state,
        financeManagerSearch: payload,
      };

    case TYPES.SET_FINANCE_MANAGER_DATES:
      return {
        ...state,
        financeManagerDates: payload,
      };

    default:
      return state;
  }
};

export default financeManagerReducer;
